import {ProductUI, type ProductUIProps} from '../ProductUI/ProductUI'
import {clsx} from 'clsx'
import {
  Product as WebGLProduct,
  type ProductProps as WebGLProductProps,
} from './../../../../../brand/components/Product/Product'

import Styles from './Product.module.css'

export type ProductProps = Omit<WebGLProductProps, 'children'> & {
  backgroundProps?: WebGLProductProps['backgroundProps']
  children: React.ReactNode
  productUI: Omit<ProductUIProps, 'children'>
}

export const defaultProps: Partial<ProductProps> = {}

export const Product = (props: ProductProps) => {
  const initializedProps: ProductProps = {...defaultProps, ...props}
  const {children, productUI, className, ...webGLProps} = initializedProps

  return (
    <div className={clsx(Styles['Product'], className)}>
      <WebGLProduct {...webGLProps}>
        <ProductUI {...productUI}>{children}</ProductUI>
      </WebGLProduct>
    </div>
  )
}
